import { Route, Routes } from "react-router-dom"
import DocumentCategoryList from "./components/DocumentCategoryList"

export default function DocumentCategoriesPage() {
  return (
    <Routes>
      <Route index element={<DocumentCategoryList />} />
      <Route path=":id" element={<DocumentCategoryList />} />
    </Routes>
  )
}
